import {useMemo} from 'react';
import {useFormikContext} from 'formik';
import {DrawerFields} from 'components/customer/Product/entity/Drawer';
import {useAppSelector} from 'store/customer';
import {toNumber} from 'components/customer/Product/Drawer/helpers';
import {
    innerDrawerGeometry,
    topPartOf,
} from 'components/customer/Product/Drawer/helpers/innerDrawerGeometry';
import {useGetCabinetTopsQuery} from 'components/customer/Room/store/roomApi';
import {DragPreview} from 'components/customer/Product/Drawer/helpers/useInnerDrawerDrag';

// The cabinet the Edit layout drawing shows, in mm, for the drawing, the
// panel beside it and the limits alike: a carcase thickness at the sides and
// bottom, and at the top whatever closes it, so the gaps shown are real. A
// drag in flight is shown, not yet in the form.
export const useInnerDrawerGeometry = (preview: DragPreview = null) => {
    const {values} = useFormikContext<DrawerFields>();
    const carcaseThickness = useAppSelector(
        (state) => state.productData.carcaseThickness
    );
    const {data: cabinetTops} = useGetCabinetTopsQuery();
    const cabinetTop = cabinetTops?.find(
        (top) => top.id == toNumber(values.cabinet_top)
    );

    return useMemo(() => {
        const height = toNumber(values.cabinet_height);
        const width = toNumber(values.cabinet_width);

        if (!(height > 0) || !(width > 0)) return null;

        const thickness = toNumber(carcaseThickness);
        const drawers = (values.drawers ?? []).map((drawer, index) =>
            preview?.index === index
                ? {...drawer, position_to_bottom: preview.position}
                : drawer
        );

        return {
            height,
            width,
            thickness,
            ...innerDrawerGeometry({
                height,
                thickness,
                topPart: topPartOf(cabinetTop, thickness),
                drawers,
            }),
        };
    }, [
        values.cabinet_height,
        values.cabinet_width,
        values.drawers,
        carcaseThickness,
        cabinetTop,
        preview,
    ]);
};
